import React from 'react';
import { alpha, Theme } from '@mui/material';
import { DateField, DateFieldProps, useRecordContext } from 'react-admin';
import get from 'lodash/get';

const DeactivatedDateField = (props: DateFieldProps) => {
  const record = useRecordContext(props);

  if (!record) {
    return null;
  }
  const value = get(record, props.source!);
  const deactivated = !(value == null || value === '');

  // Taken from the theme, so the red stays readable on a dark page too.
  return (
    <DateField
      {...props}
      sx={{
        color: deactivated ? 'error.main' : 'unset',
        bgcolor: (theme: Theme) => (deactivated ? alpha(theme.palette.error.main, 0.12) : 'unset'),
        padding: '5px',
        fontWeight: 'bold',
        borderRadius: '3px'
      }}
    />
  );
};

export default DeactivatedDateField;
